import { ListItem, ListItemIcon } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import s from './Sidebar.module.scss';

type Props = {
  text: string;
  icon: React.ReactNode;
  isActive?: boolean;
  showText: boolean;
  /** Пункт внутри группы — с отступом, когда сайдбар развёрнут */
  nested?: boolean;
  /** Справа от текста: шеврон группы */
  suffix?: React.ReactNode;
  onClick: () => void;
};

// Иконки по центру свёрнутого сайдбара (45px): у 24px иконки центр на 22px.
// Маленькая иконка подпункта (18px) после линии группы (2px) — на той же оси
const ITEM_PADDING = '4px 8px 4px 10px';
const getNestedPadding = (showText: boolean) =>
  showText ? '4px 8px 4px 22px' : '4px 8px 4px 11px';

export const SidebarLink: React.FC<Props> = ({
  text,
  icon,
  isActive = false,
  showText,
  nested = false,
  suffix,
  onClick,
}) => (
  <ListItem
    onClick={onClick}
    className={clsx(s['root__list-item'], {
      [s.active]: isActive,
      [s['root__list-item_nested']]: nested,
    })}
    sx={{
      padding: nested ? getNestedPadding(showText) : ITEM_PADDING,
      cursor: 'pointer',
      '&:hover': {
        '& .MuiListItemIcon-root': {
          color: 'var(--hover-color)',
          transition: '0.2s',
        },
      },
    }}
  >
    <ListItemIcon
      sx={{
        minWidth: 'fit-content',
        color: isActive ? 'var(--hover-color)' : 'var(--additional-color)',
        transition: '0.2s',
      }}
    >
      {icon}
    </ListItemIcon>
    {showText && <p>{text}</p>}
    {showText && suffix && <span className={s['root__list-suffix']}>{suffix}</span>}
  </ListItem>
);
